import { Laptop, Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import { Button } from "@/components/ui/button";
import type { ThemeMode } from "@/stores/ui-store";
import { cn } from "@/lib/cn";

const ORDER: ThemeMode[] = ["light", "dark", "system"];
const ICONS: Record<ThemeMode, typeof Sun> = {
  light: Sun,
  dark: Moon,
  system: Laptop,
};
const LABELS: Record<ThemeMode, string> = {
  light: "Light",
  dark: "Dark",
  system: "System",
};

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];
  const Icon = ICONS[theme];

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("rounded-full", className)}
      aria-label={`Theme: ${LABELS[theme]}. Click to switch to ${LABELS[next]}.`}
      title={`Theme: ${LABELS[theme]}`}
      onClick={() => setTheme(next)}
    >
      <Icon className="h-[1.1rem] w-[1.1rem]" />
    </Button>
  );
}
